import * as Errors from '../aeppic/errors/index.js'

// Symbol.asyncIterator polyfill
if (!Symbol.asyncIterator) {
  (Symbol as any).asyncIterator = Symbol.for('Symbol.asyncIterator')
}

export { default } from './aeppic.js'
export * from './warn.js'
export * from './aeppic.js'
export { EditContext, EditContextHandle, EditContextRegistry, findEditContextInDOM } from './edit-context.js'
export * from './selection.js'
export * from './navigation.js'
export * from './cached-query-api.js'
export * from './commands/index.js'
export * from './actions.js'
export * from './validations.js'
export { WriteLockedAeppic } from './write-locked-aeppic.js'
export { LOCAL_READ_MODEL_FEATURE, LOCAL_READ_MODEL_MEMORY_KEY, LocalFirstServerAdapter } from './local-first-server-adapter.js'
export { perf } from './perf.js'
export { LAYERED_OVERLAYS_FEATURE, getLogicalParentNode } from './overlay-host.js'
export { LocalModel } from './local-model.js'
export { APP_MANIFEST_FEATURE, AppManifest } from './app-manifest.js'
export type { AppManifestValues } from './app-manifest.js'
export type {
  ILocalReadModelAdapter,
  LocalDocumentsResult,
  LocalFindResult,
  LocalFirstServerAdapterOptions,
  LocalReadModelFactory,
} from './local-first-server-adapter.js'
export type { LocalModelApi, LocalModelError, LocalModelPhase, LocalModelRoute, LocalModelState } from './local-model.js'
export { getPreviousChanges, PreviousChange, PreviousFieldChange, PreviousFormChange, PreviousListChange, PreviousValueChange } from '../model/previous.js'
// export { SignatureStats, wrapWithSignatureTracking } from './signature-track.js'

export { Errors }
export { Router } from './router.js'
export type { IRouter } from './router.js'

export { WebSocketConnection } from './websocket/index.js'
export * from './formatting.js'
export * from './financial.js'
export { createBinaryAPI } from './binary.js'
export { Uploads } from './uploads/index.js'
